import React, {useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {freeCreditToUser} from '../../../AllCellCastUser/UserProfileDetail/UserProfileDetailSlice/UserProfileDetailSlice'
import {WhiteLabelfreeCreditToUser} from '../WhiteLabelProfileSlice/WhiteLAbelSlice'

const WhiteLabelAddCreditPopup = ({show, handleClose}: any) => {
  const dispatch = useDispatch()
  const UserProfileData = useSelector(
    (state: any) => state?.ProfileData?.ProfileData?.items?.[0]?.user
  )
  const ProfileDetatileState = useSelector(
    (state: any) => state?.ProfileData?.ProfileData?.items?.[0]
  )

  console.log(ProfileDetatileState, '8888888888888888888888')

  const [quickSms, setQuickSms] = useState('mms')
  const [credit, setCredit] = useState<any>(0)

  const SubmmitFreeCreadit = () => {
    dispatch(
      WhiteLabelfreeCreditToUser({
        accountId: ProfileDetatileState?._id,
        userId: UserProfileData?._id,
        noOfCredit: credit,
        campType: quickSms,
      })
    )
  }

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-700px'
        className='vh-100'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header border-bottom'>
          <h2>Add credits</h2>
          <div className='btn btn-icon btn-sm' onClick={handleClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body p-20 pb-15'>
          <div className='row mb-2'>
            <div className='border-end pe-15'>
              <div className='d-flex gap-4'>
                <div>
                  <input
                    type='radio'
                    className='btn-check'
                    name='sms'
                    checked={quickSms == 'sms'}
                    id='quick_sms_radio2'
                    onClick={() => {
                      setQuickSms('sms')
                    }}
                  />
                  <label className='btn btn-light-info py-2 px-5' htmlFor='quick_sms_radio2'>
                    <span className='fw-500 fs-2'>SMS</span>
                  </label>
                </div>
                <div>
                  <input
                    type='radio'
                    className='btn-check'
                    name='mms'
                    checked={quickSms == 'mms'}
                    id='quick_mms_radio2'
                    onClick={() => {
                      setQuickSms('mms')
                    }}
                  />
                  <label
                    className='btn btn-active-info btn-light-info py-2 px-5'
                    htmlFor='quick_mms_radio2'
                  >
                    <span className='fw-500 fs-2'>MMS</span>
                  </label>
                </div>
              </div>
              <div className='mt-7'>
                <label className=' col-form-label fw-normal fs-6'>
                  How many credits should be added?
                </label>
                <input
                  onChange={(e: any) => setCredit(e.target.value)}
                  name='Type'
                  type='text'
                  className='form-control form-control-lg form-control-solid mb-4 w-100 text-bg-light d-block'
                />
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block text-danger'></div>
                </div>
              </div>
            </div>
            {/* <div className='col-5 ps-10'>
            <h4 className='mb-4'>Total cost</h4>
            <h1 className='text-info fs-3qx fw-boldest'>$1000</h1>
            <div className='fs-6 text-gray-500'>or 0,34/message</div>
          </div> */}
            <div className='d-flex flex-center mt-20'>
              <div id='kt_drawer_chat_close'>
                <button
                  type='button'
                  onClick={handleClose}
                  className='btn btn-light text-hover-white rounded btn-active-primary me-3 w-100px p-3 fw-500 me-2'
                >
                  Discard
                </button>
              </div>

              <button
                disabled={isNaN(credit) || credit == 0 || credit == ''}
                type='submit'
                className='btn btn-light btn-primary fw-500 rounded  w-100px p-3 border border-primary'
                onClick={() => {
                  SubmmitFreeCreadit()
                  handleClose()
                }}
              >
                <span className='indicator-label'>Submit</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default WhiteLabelAddCreditPopup
